import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, getInputMaskByOpenApiSchemaProperty } from '@/utils'

import info from '@/components/info'
import countryCode from '@/components/services/country-regions/commons/countryCode'
import { countryRegionsFields, countryRegionsUpperCaseInputMask } from '@/components/services/country-regions/utils'
import validationInfo from '@/components/validationInfo'

function renderTextField(h, fieldName, index) {
  const { mask, maskOptions } = getInputMaskByOpenApiSchemaProperty(this.fieldsProperties[fieldName]) || {}

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy[fieldName],
        label: this.getTranslate(`${Services['country-regions']}.labels.${fieldName}`),
        mask,
        maskOptions,
        dense: true,
        clearable: true,
        details: false,
        autofocus: this.isNew && index === 0,
        required: this.fieldsRequired[fieldName]
      },
      on: {
        input: event => {
          this.proxy[fieldName] = event
        }
      }
    }
  )
}

function renderCountryCodeField(h) {
  return h(
    countryCode,
    {
      props: {
        value: this.proxy.countryCode,
        property: this.fieldsProperties.countryCode,
        required: this.fieldsRequired.countryCode
      },
      on: {
        input: event => {
          this.proxy.countryCode = event
        }
      }
    }
  )
}
function renderTimeZoneField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.timeZone,
        label: this.getTranslate(`${Services['country-regions']}.labels.timeZone`),
        items: this.timeZoneItems,
        mask: countryRegionsUpperCaseInputMask.mask,
        maskOptions: countryRegionsUpperCaseInputMask.maskOptions,
        dense: true,
        clearable: !this.fieldsRequired.timeZone,
        details: false,
        combobox: true,
        setOnBlur: true,
        required: this.fieldsRequired.timeZone,
        setRequiredOnMounted: false
      },
      on: {
        input: event => {
          this.proxy.timeZone = event
        }
      }
    }
  )
}

function renderField(h, fieldName, index) {
  switch (fieldName) {
    case 'countryCode': return renderCountryCodeField.call(this, h)
    case 'timeZone': return renderTimeZoneField.call(this, h)
    default: return renderTextField.call(this, h, fieldName, index)
  }
}
function renderFields(h) {
  return h(
    'div',
    {
      class: `${Services['country-regions']}-form__fields`
    },
    countryRegionsFields.map((fieldName, index) => {
      return renderField.call(this, h, fieldName, index)
    })
  )
}

function renderValidationInfo(h) {
  return h(
    validationInfo,
    {
      props: {
        value: this.validationGroups
      }
    }
  )
}
function renderDescription(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services['country-regions']}.infos.form`)
      }
    }
  )
}
function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services['country-regions']}.warnings.form`),
        color: Colors.warning
      }
    }
  )
}
function renderAside(h) {
  return h(
    'div',
    {
      class: `${Services['country-regions']}-form__aside`
    },
    [
      renderValidationInfo.call(this, h),
      renderDescription.call(this, h),
      renderWarning.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services['country-regions']}-form`]: true,
        [`${Services['country-regions']}-form--new`]: this.isNew,
        [`${Services['country-regions']}-form--columns`]: this.viewport.breakpoint.mdUp
      }
    },
    [
      renderFields.call(this, h),
      renderAside.call(this, h)
    ]
  )
}
